import { gql } from 'graphql-request';

export const createShopifyProductQuery = (handle) => {
    return gql`{
  productByHandle(handle: "${handle}") {
    id
    title
    vendor
    availableForSale
    descriptionHtml
    productType
    tags
    handle
    collections(first: 1) {
      nodes {
        handle
        title
      }
    }
    images(first: 20) {
      nodes {
        src
        id
        altText
      }
    }
    metafields(identifiers: [
        {namespace: "c_f", key: "additional_items"},
        {namespace: "c_f", key: "substitutes"},
        {namespace: "c_f", key: "components"},
        {namespace: "c_f", key: "min_order_multiplier"},
        {namespace: "c_f", key: "min_order_quantity"},
        {namespace: "c_f", key: "unit_measurement"},
        {namespace: "c_f", key: "packing_unit"},
    ]){
          description
          id
          key
          namespace
          type
          updatedAt
          value
          createdAt
    }
    variants(first: 50) {
      nodes {
        id
        price {
          amount
          currencyCode
        }
        priceV2 {
          amount
          currencyCode
        }
        quantityAvailable
        sku
        title
        weight
        weightUnit
        unitPrice {
          amount
          currencyCode
        }
        compareAtPrice {
          amount
          currencyCode
        }
        compareAtPriceV2 {
          amount
          currencyCode
        }
        currentlyNotInStock
        availableForSale
      }
      pageInfo {
        hasNextPage
        startCursor
      }
     }
    }
}
`;
};
